import { render, staticRenderFns } from "./ChatsView.vue?vue&type=template&id=988a112a&scoped=true"
import script from "./ChatsView.vue?vue&type=script&lang=js"
export * from "./ChatsView.vue?vue&type=script&lang=js"
import style0 from "./ChatsView.vue?vue&type=style&index=0&id=988a112a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988a112a",
  null
  
)

export default component.exports